<?xml version="1.0" encoding="UTF-8"?>
<svg width="1000px" height="1000px" viewBox="0 0 1000 1000" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <g>
    <g>
      <rect fill="currentColor" x="0" y="0" width="1000" height="1000" rx="145"></rect>
      <polygon fill="#FFFFFF" points="433.163995 597.708667 301.751214 456.415033 215 549.689023 435.715501 787 479.091108 737.619652 858 305.530637 768.697279 215"></polygon>
    </g>
  </g>
</svg>
